const NotMatch = () => (
  <div>
    <p>Not found!</p>
  </div>
);
export default NotMatch;
